import { useCallback } from 'react';
import { useCountryClientTypePricingRuleDeleteMutation } from 'api';
import { notification } from 'components';
import { ErrorMappingValueType } from 'typings';
import { useParams } from 'react-router-dom';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const { id } = useParams() as { id: string };
  const [notificationApi, contextHolder] = notification.useNotification();
  const [countryClientTypePricingRuleDelete, { isLoading }] = useCountryClientTypePricingRuleDeleteMutation();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({ message: message });
    },
    [notificationApi]
  );

  const onRemoveConfirm = useCallback(
    async (dataToDelete: { id: string | undefined }) => {
      try {
        const { data, error }: any = await countryClientTypePricingRuleDelete({
          countryId: id,
          clientTypePricingRulesId: dataToDelete.id,
        });
        if (data?.success) {
          openNotificationWithIcon({
            type: 'success',
            message: `The Client Type Pricing Rule was successfully deleted.`,
          });
          onDeleteModalClose();
        } else if (error?.data?.success === false) {
          const { data = {} } = error.data;
          Object.keys(data).forEach((_key: string) => {
            openNotificationWithIcon({
              type: 'error',
              message: data[_key],
            });
          });
        } else {
          openNotificationWithIcon({
            type: 'error',
            message: error?.data?.error || 'Something went wrong!',
          });
        }
      } catch (err) {
        console.error('Error deleting Client Type Pricing Rules:', err);
        openNotificationWithIcon({
          type: 'error',
          message: 'An unexpected error occurred!',
        });
      }
    },
    [countryClientTypePricingRuleDelete, openNotificationWithIcon, onDeleteModalClose, id]
  );

  return {
    onRemoveConfirm,
    contextHolder,
    isLoading,
  };
};
